import { RouteRecordRaw } from "vue-router";

export function layout(children: RouteRecordRaw[], path = ""): RouteRecordRaw {
  return {
    children,
    component: () =>
      import(
        /* webpackChunkName: "layout-[request]" */
        "@/layout/Index.vue"
      ),
    path
  };
}
